<template>
    <div>
        <!-- summary block -->
        <div v-if="(mode === 'business' && mondayDelivery) || (mode==='private' && privateDeliveryDay === 'monday')" class="d-flex">
            <div class="order-summary__subscription__col-1 text-container">
                <h2>Montagslieferung:</h2>
                <!-- <h2 v-if="mode === 'business'">Montagslieferung:</h2> -->
                <!-- <h2 v-else-if="subscriptionType">{{ subscriptionType.name }}:</h2> -->
            </div>
            <div class="order-summary__subscription__col-2">
                <div
                    class="order-result-summary overview"
                >
                    <div class="order-result-summary__col">
                        <div class="order-result-summary__text-container text-container">
                            <!-- <h4 v-if="mode === 'private'">Montagslieferung</h4> -->
                            <!-- <h4 v-else-if="subscriptionType">{{ subscriptionType.name }}</h4> -->
                            <h4 v-if="subscriptionType">{{ subscriptionType.name }}</h4>
                            <p>{{ interval('monday').name }}</p>
                        </div>
                    </div>
                    <div class="order-result-summary__col">
                        <div class="order-result-summary__baskets__list">
                            <div
                                v-for="(basket, index) in sortedBasketsMonday"
                                :key="`monday-basket-${index}`"
                                class="order-result-summary__weight-container"
                            >
                                <span class="order-result-summary__weight-text">
                                    {{ basket.kg }} kg
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <template v-if="mode === 'business'"> -->
                <template>
                    <div
                        v-for="(basketId, basketIndex) in Object.keys(groupedBasketsExtra['monday'])"
                        :key="`order-summary-monday-${basketIndex}`"
                        class="order-result-summary overview divider-2"
                    >
                        <div class="order-result-summary__col">
                            <div class="order-result-summary__text-container text-container">
                                <h4>{{ groupedBasketsExtra['monday'][basketId][0].name }}</h4>
                                <p>
                                    {{ getIntervals(groupedBasketsExtra['monday'][basketId][0].interval) }}<br>
                                    {{ basketsExtraCount('monday', basketId, true) }}x {{ groupedBasketsExtra['monday'][basketId][0].unit }}
                                </p>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!-- Extras of monday in the private mode -->
        <!-- <template v-if="mode === 'private' && Object.keys(groupedBasketsExtra['monday']).length">
            <template
                v-for="(basketId, basketIndex) in Object.keys(groupedBasketsExtra['monday'])"
            >
                <div :key="`order-summary-basket-monday-${basketIndex}`" class="d-flex">
                    <div class="order-summary__subscription__col-1 text-container">
                        <h2>{{ groupedBasketsExtra['monday'][basketId][0].name }}:</h2>
                    </div>
                    <div class="order-summary__subscription__col-2">
                        <div
                            class="order-result-summary overview"
                        >
                            <div>
                                <div class="order-result-summary__text-container text-container">
                                    <h4>Montagslieferung</h4>
                                    <p>
                                        {{ getIntervals(groupedBasketsExtra['monday'][basketId][0].interval) }}<br>
                                        {{ basketsExtraCount('monday', basketId) }}x {{ groupedBasketsExtra['monday'][basketId][0].per_unit.replace('pro ', '') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template> -->
        <!-- summary block -->
        <div v-if="(wednesdayDelivery && subscriptionType) || Object.keys(groupedBasketsExtra['wednesday']).length" class="d-flex">
            <div class="order-summary__subscription__col-1 text-container">
                <h2>Mittwochslieferung:</h2>
                <!-- <h2 v-if="mode === 'business'">Mittwochslieferung:</h2> -->
                <!-- <h2 v-else>{{ subscriptionType.name }}: </h2> -->
            </div>
            <div class="order-summary__subscription__col-2">
                <div
                    v-if="wednesdayDelivery && subscriptionType"
                    class="order-result-summary overview"
                >
                    <div class="order-result-summary__col">
                        <div class="order-result-summary__text-container text-container">
                            <!-- <h4 v-if="mode === 'private'">Mittwochslieferung</h4> -->
                            <!-- <h4 v-else>{{ subscriptionType.name }}</h4> -->
                            <h4>{{ subscriptionType.name }}</h4>
                            <p>{{ interval('wednesday').name }}</p>
                        </div>
                    </div>
                    <div class="order-result-summary__col">
                        <div class="order-result-summary__baskets__list">
                            <div
                                v-for="(basket, index) in sortedBbasketsWednesday"
                                :key="`wednesday-basket-${index}`"
                                class="order-result-summary__weight-container"
                            >
                                <span class="order-result-summary__weight-text">
                                    {{ basket.kg }} kg
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <template>
                    <div
                        v-for="(basketId, basketIndex) in Object.keys(groupedBasketsExtra['wednesday'])"
                        :key="`order-summary-wednesday-${basketIndex}`"
                        :class="{'divider-2': wednesdayDelivery}"
                        class="order-result-summary overview"
                    >
                        <div class="order-result-summary__col">
                            <div class="order-result-summary__text-container text-container">
                                <h4>{{ groupedBasketsExtra['wednesday'][basketId][0].name }}</h4>
                                <p>
                                    {{ getIntervals(groupedBasketsExtra['wednesday'][basketId][0].interval) }}<br>
                                    {{ basketsExtraCount('wednesday', basketId, true) }}x {{ groupedBasketsExtra['wednesday'][basketId][0].unit }}
                                </p>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!-- Extras of wednesday in the private mode -->
        <!-- <template v-if="mode === 'private' && Object.keys(groupedBasketsExtra['wednesday']).length">
            <template
                v-for="(basketId, basketIndex) in Object.keys(groupedBasketsExtra['wednesday'])"
            >
                <div :key="`order-summary-basket-wednesday-${basketIndex}`" class="d-flex">
                    <div class="order-summary__subscription__col-1 text-container">
                        <h2>{{ groupedBasketsExtra['wednesday'][basketId][0].name }}:</h2>
                    </div>
                    <div class="order-result-summary overview">
                        <div>
                            <div class="order-result-summary__text-container text-container">
                                <h4>Mittwochslieferung</h4>
                                <p>{{ getIntervals(groupedBasketsExtra['wednesday'][basketId][0].interval) }}<br>
                                    {{ basketsExtraCount('wednesday', basketId) }}x {{ groupedBasketsExtra['wednesday'][basketId][0].unit }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template> -->
    </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';

import priceMixin from '../mixins/priceMixin';

export default {
    mixins: [
        priceMixin,
    ],
    computed: {
        ...mapState({
            mode: state => state.mode,
            privateDeliveryDay: state => state.privateDeliveryDay,
            intervals: state => state.intervals,
            orderableIntervals: state => state.orderable.intervals,
            basketExtra: state => state.basketExtra,
        }),
        ...mapGetters([
            'subscriptionType',
            'amounts',
            'appetites',
            'orderableBaskets',
            'groupedBaskets',
            'allBaskets',
            'sortedBasketsMonday',
            'sortedBbasketsWednesday',
            'groupedBasketsExtra',
        ]),
        wednesdayDelivery() {
            return this.sortedBbasketsWednesday.length;
        },
        mondayDelivery() {
            return this.sortedBasketsMonday.length;
        },
    },
    methods: {
        getIntervals(id) {
            const item = this.orderableIntervals.filter(p => p.id === id);
            return item.length ? item[0].name : '';
        },
    },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ResultsOverview.vue?ac7a5a5a